<template>
  <div class="mt-5">
    <v-container class="text-center">
      <v-divider class="mb-1"></v-divider>
      <v-divider class="mb-10"></v-divider>

      <v-img
        class="ems-image mb-8"
        contain
        max-height="70%"
        src="@/assets/ems_images/ems.png"
      ></v-img>

      <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720"
        >Executive Maintenance Services had its beginnings as a cleaning company
        catering to the condominium industry in the Greater Toronto Area.
        Fast-forward 40 years, and we have expanded services to include
        superintendents, mould and asbestos remediation, carpet cleaning,
        underground garage cleaning, renovations, and repairs. We have become a
        one-stop shop for all services that a property management company needs
        to provide their Condominium clients easy access to first class
        services.
      </v-responsive>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "services",
  components: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
</style>